export default __webpack_public_path__ + "static/SRC 3340 - Product Specifications & Technical Data-0c48a53c8176c24a8aae059311572b76.pdf";